import React from 'react';
import { Else, If, Then } from 'react-if';
import classnames from 'classnames';
import styles from './PageTitle.module.scss';

const PageTitle = ({
  convertMarginTopToPaddingTop = false,
  titleHtml,
  titleText,
  titleClass,
  subTitleHtml,
  subTitleText,
  subTitleClass,
  subTitleDescHtml,
  subTitleDescText,
  subTitleDescClass,
}) => (
  <div className={classnames('container', styles.headerTitle, convertMarginTopToPaddingTop ? 'mtToPt' : '')}>
    <If condition={titleText != null}>
      <Then>
        <div className={classnames('main-title', titleClass)}>{titleText}</div>
      </Then>
      <Else>
        <If condition={titleHtml != null}>
          <Then>
            <div className={classnames(styles.headerTitleContainer)}>{titleHtml}</div>
          </Then>
        </If>
      </Else>
    </If>
    <If condition={subTitleText != null}>
      <Then>
        <div className={classnames('main-sub-title', subTitleClass)}>{subTitleText}</div>
      </Then>
      <Else>
        <If condition={subTitleHtml != null}>
          <Then>
            <div className={classnames(styles.headerSubTitleContainer)}>{subTitleHtml}</div>
          </Then>
        </If>
      </Else>
    </If>
    <If condition={subTitleDescText != null}>
      <Then>
        <div className={classnames('item-title-font-size-small', subTitleDescClass)} style={{ fontWeight: 'bold' }}>
          {subTitleDescText}
        </div>
      </Then>
      <Else>
        <If condition={subTitleDescHtml != null}>
          <Then>
            <div className={classnames(styles.headerSubTitleDescContainer)}>{subTitleDescHtml}</div>
          </Then>
        </If>
      </Else>
    </If>
  </div>
);

export default PageTitle;
